import Gavina91 from '../../../../src/media/fasad/Gavina 9.webp'
import Gavina92 from '../../../../src/media/fasad/Gavina 9.webp'

const Gavina9images =[
Gavina91,Gavina92
]

export default Gavina9images;